export function phoneNumber(number) {
  return parseInt(number.replace(/[^0-9]/g, ""), 10);
}
